/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bland_Few_Bird_HuntInputs */

const fr_bland_few_bird_hunt = /** @type {(inputs: Bland_Few_Bird_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminée`)
};

/**

* @param {Bland_Few_Bird_HuntInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bland_few_bird_hunt = /** @type {((inputs?: Bland_Few_Bird_HuntInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bland_Few_Bird_HuntInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bland_few_bird_hunt(inputs)
});